import difference from 'lodash/difference';
import pick from 'lodash/pick';
export const componentBaseRenderer = (props) => {
    const { source, state, debug, onGetProps, onGetItem, onDestroyItems, onAddItems, onUpdateState, onItemRedraw, } = props;
    const { isNewItemAdded, isItemUpdated, items: newItems, updated: updatedItems, } = Object.values(source).reduce((acc, item) => {
        const { id } = item;
        const isItemCreated = !!state[id];
        const props = onGetProps(item);
        if (!isItemCreated) {
            acc.isNewItemAdded = true;
            acc.items[id] = onGetItem(props);
        }
        else {
            const item = state[id];
            const isChanged = item.isChanged(props);
            if (isChanged) {
                item.redraw(props);
                acc.isItemUpdated = true;
                acc.updated[id] = item;
            }
            else {
                item.updatePropsWithoutRedraw(props);
            }
        }
        return acc;
    }, {
        isNewItemAdded: false,
        isItemUpdated: false,
        items: {},
        updated: {},
    });
    const itemIds = Object.keys(state);
    const sourceItemIds = Object.keys(source);
    const removedItemIds = difference(itemIds, sourceItemIds);
    const isItemRemoved = removedItemIds.length > 0;
    if (debug) {
        const { name, canvasDebugger } = debug;
        if (isNewItemAdded) {
            const addedItemIds = Object.keys(newItems);
            canvasDebugger === null || canvasDebugger === void 0 ? void 0 : canvasDebugger.debug('Component Renderer', `Added ${addedItemIds.length} ${name} items`, addedItemIds);
        }
        if (isItemUpdated) {
            const updatedItemIds = Object.keys(updatedItems);
            canvasDebugger === null || canvasDebugger === void 0 ? void 0 : canvasDebugger.debug('Component Renderer', `Updated ${updatedItemIds.length} ${name} items`, updatedItemIds);
        }
        if (isItemRemoved) {
            canvasDebugger === null || canvasDebugger === void 0 ? void 0 : canvasDebugger.debug('Component Renderer', `Removed ${removedItemIds.length} ${name} items`, removedItemIds);
        }
    }
    if (isItemUpdated) {
        onItemRedraw === null || onItemRedraw === void 0 ? void 0 : onItemRedraw(updatedItems);
    }
    if (isItemRemoved) {
        onDestroyItems(removedItemIds);
    }
    if (isNewItemAdded) {
        onAddItems(newItems);
    }
    if (isNewItemAdded || isItemRemoved) {
        onUpdateState((items) => (Object.assign(Object.assign({}, pick(items, sourceItemIds)), newItems)));
    }
};
